import * as React from "react"

function SvgVideoPlayerMovie(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 27 22"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      >
        <path d="M3.604 1.104h19.792c1.15 0 2.083.932 2.083 2.083v15.625a2.083 2.083 0 01-2.083 2.084H3.604a2.083 2.083 0 01-2.083-2.084V3.187c0-1.15.932-2.083 2.083-2.083z" />
        <path d="M16.135 11.699a.743.743 0 000-1.398l-4.75-1.727a.365.365 0 00-.49.343v4.166a.364.364 0 00.49.343l4.75-1.727zM1.521 5.271h23.958M1.521 16.729h23.958M4.906 2.927a.26.26 0 110 .521.26.26 0 010-.52m4.297-.001a.26.26 0 110 .521.26.26 0 010-.52m12.891-.001a.26.26 0 100 .521.26.26 0 000-.52m-4.297-.001a.26.26 0 100 .521.26.26 0 000-.52M13.5 2.927a.26.26 0 110 .521.26.26 0 010-.52M4.906 18.552a.26.26 0 100 .521.26.26 0 000-.52m4.297-.001a.26.26 0 100 .521.26.26 0 000-.52m12.891-.001a.26.26 0 110 .521.26.26 0 010-.52m-4.297-.001a.26.26 0 110 .521.26.26 0 010-.52m-4.297-.001a.26.26 0 100 .521.26.26 0 000-.52" />
      </g>
    </svg>
  )
}

export default SvgVideoPlayerMovie
